var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSubmitPrompt = function SvgIconSubmitPrompt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A4A4A4",
    d: "m2.01 3.03 7.51 3.22-7.52-1zm7.5 8.72L2 14.97v-2.22zM.01 0 0 7l15 2-15 2 .01 7L21 9z"
  })));
};
export default SvgIconSubmitPrompt;